// Version : 0.0.1
// Author : SABARI
import RoleActionTypes from './role.types';

/** ***************** GET ROLE LIST START *********************** */
export const getRoleListStart = (getData: any) => ({
	type: RoleActionTypes.GET_ROLE_LIST_START,
	payload: getData,
});

export const getRoleListSuccess = (successData: any) => ({
	type: RoleActionTypes.GET_ROLE_LIST_SUCCESS,
	payload: successData,
});

export const getRoleListFailure = (failureData: any) => ({
	type: RoleActionTypes.GET_ROLE_LIST_FAILURE,
	payload: failureData,
});

export const getRoleListResponseResetStart = () => ({
	type: RoleActionTypes.GET_ROLE_LIST_RESPONSE_RESET,
});

export const getRoleListResponseChanged = () => ({
	type: RoleActionTypes.GET_ROLE_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ROLE LIST END *********************** */

/** ***************** ADD ROLE DETAILS START *********************** */
export const addRoleDetailsStart = (addData: any) => ({
	type: RoleActionTypes.ADD_ROLE_DETAILS_START,
	payload: addData,
});

export const addRoleDetailsSuccess = (successData: any) => ({
	type: RoleActionTypes.ADD_ROLE_DETAILS_SUCCESS,
	payload: successData,
});

export const addRoleDetailsFailure = (failureData: any) => ({
	type: RoleActionTypes.ADD_ROLE_DETAILS_FAILURE,
	payload: failureData,
});

export const addRoleDetailsResponseResetStart = () => ({
	type: RoleActionTypes.ADD_ROLE_DETAILS_RESPONSE_RESET,
});

export const addRoleDetailsResponseChanged = () => ({
	type: RoleActionTypes.ADD_ROLE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD ROLE DETAILS END *********************** */

/** ***************** UPDATE ROLE DETAILS START *********************** */
export const updateRoleDetailsStart = (updateData: any) => ({
	type: RoleActionTypes.UPDATE_ROLE_DETAILS_START,
	payload: updateData,
});

export const updateRoleDetailsSuccess = (successData: any) => ({
	type: RoleActionTypes.UPDATE_ROLE_DETAILS_SUCCESS,
	payload: successData,
});

export const updateRoleDetailsFailure = (failureData: any) => ({
	type: RoleActionTypes.UPDATE_ROLE_DETAILS_FAILURE,
	payload: failureData,
});

export const updateRoleDetailsResponseResetStart = () => ({
	type: RoleActionTypes.UPDATE_ROLE_DETAILS_RESPONSE_RESET,
});

export const updateRoleDetailsResponseChanged = () => ({
	type: RoleActionTypes.UPDATE_ROLE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE ROLE DETAILS END *********************** */

/** ***************** DELETE ROLE DETAILS START *********************** */
export const deleteRoleDetailsStart = (deleteData: any) => ({
	type: RoleActionTypes.DELETE_ROLE_DETAILS_START,
	payload: deleteData,
});

export const deleteRoleDetailsSuccess = (successData: any) => ({
	type: RoleActionTypes.DELETE_ROLE_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteRoleDetailsFailure = (failureData: any) => ({
	type: RoleActionTypes.DELETE_ROLE_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteRoleDetailsResponseResetStart = () => ({
	type: RoleActionTypes.DELETE_ROLE_DETAILS_RESPONSE_RESET,
});

export const deleteRoleDetailsResponseChanged = () => ({
	type: RoleActionTypes.DELETE_ROLE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE ROLE DETAILS END *********************** */

/** ***************** FETCH ROLE DETAILS START *********************** */
export const fetchRoleDetailsStart = (fetchData: any) => ({
	type: RoleActionTypes.FETCH_ROLE_DETAILS_START,
	payload: fetchData,
});

export const fetchRoleDetailsSuccess = (successData: any) => ({
	type: RoleActionTypes.FETCH_ROLE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchRoleDetailsFailure = (failureData: any) => ({
	type: RoleActionTypes.FETCH_ROLE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchRoleDetailsResponseResetStart = () => ({
	type: RoleActionTypes.FETCH_ROLE_DETAILS_RESPONSE_RESET,
});

export const fetchRoleDetailsResponseChanged = () => ({
	type: RoleActionTypes.FETCH_ROLE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH ROLE DETAILS END *********************** */
